import store from '@/store'
import DOMPurify from 'dompurify'

DOMPurify.addHook(
  'uponSanitizeAttribute',
  function (currentNode, hookEvent, config) {
    // DOMPurify会移除a标签的target=_blank属性，故a标签暂不做处理
    if (currentNode.tagName === 'A') {
      hookEvent.forceKeepAttr = true;
    }
  }
);

/**
 * logo组件
 */
const getLogoUrl = function() {
  let component = store.getters.components.find(item => item.sceneId === '210011');
  return component ? component.content : '';
}

/**
 * 客服热线
 */
const getCustomerHotline = function() {
  let component = store.getters.components.find(item => item.sceneId === '210012');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 页脚文案
 */
const getFooter = function() {
  let component = store.getters.components.find(item => item.sceneId === '210013');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 背景图片
 */
const getBackgroundImgUrl = function() {
  let component = store.getters.components.find(item => item.sceneId === '210014');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 官网首页
 */
const getOfficialwebsite = function() {
  let component = store.getters.components.find(item => item.sceneId === '210015');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 网站图标
 */
const getWebsiteIcon = function() {
  let component = store.getters.components.find(item => item.sceneId === '210016');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 买入页温馨提示
 */
const getBuyTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '410011');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 交易规则买入提示1
 */
const getBuyRuleTip1 = function() {
  let component = store.getters.components.find(item => item.sceneId === '410012');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 交易规则买入提示2
 */
const getBuyRuleTip2 = function() {
  let component = store.getters.components.find(item => item.sceneId === '410013');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 交易规则买入提示3
 */
const getBuyRuleTip3 = function() {
  let component = store.getters.components.find(item => item.sceneId === '410014');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 交易规则赎回提示1
 */
const getRedeemRuleTip1 = function() {
  let component = store.getters.components.find(item => item.sceneId === '410015');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 交易规则赎回提示2
 */
const getRedeemRuleTip2 = function() {
  let component = store.getters.components.find(item => item.sceneId === '410016');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 赎回页温馨提示
 */
const getRedeemTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '410017');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 转换页温馨提示
 */
const getTransTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '410018');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 修改分红方式页温馨提示
 */
const getModifyBonusTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '410019');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 撤单页温馨提示
 */
const getWithdrawsTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '4100110');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 募集账户-公募
 */
const getPubRemitAccount = function() {
  let component = store.getters.components.find(item => item.sceneId === '4100112');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 定投页温馨提示
 */
const getFixInvestTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '4100115');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 风测-风险告知
 */
const getRiskInform = function() {
  let component = store.getters.components.find(item => item.sceneId === '910011');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 风测-温馨提示
 */
const getRiskTestTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '910012');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 风测-投资者类型及风险匹配告知书
 */
const getRiskMatchNotice = function() {
  let component = store.getters.components.find(item => item.sceneId === '910013');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 风测-投资者确认函
 */
const getInvestorConfirmation = function() {
  let component = store.getters.components.find(item => item.sceneId === '910014');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 银行卡管理-温馨提示
 */
const getBankManageTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '1010011');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 基金交易-超宝买入页温馨提示
 */
const getSuperMoneyBuyTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '4100116');
  return component ? DOMPurify.sanitize(component.content) : '';
}

/**
 * 基金交易-超宝定投页温馨提示
 */
const getSuperMoneyFixInvestTips = function() {
  let component = store.getters.components.find(item => item.sceneId === '4100117');
  return component ? DOMPurify.sanitize(component.content) : '';
}

export {
	getLogoUrl,
  getCustomerHotline,
  getFooter,
  getBackgroundImgUrl,
  getOfficialwebsite,
  getWebsiteIcon,
  getBuyTips,
  getBuyRuleTip1,
  getBuyRuleTip2,
  getBuyRuleTip3,
  getRedeemRuleTip1,
  getRedeemRuleTip2,
  getRedeemTips,
  getTransTips,
  getModifyBonusTips,
  getWithdrawsTips,
  getPubRemitAccount,
  getFixInvestTips,
  getRiskInform,
  getRiskTestTips,
  getRiskMatchNotice,
  getInvestorConfirmation,
  getBankManageTips,
  getSuperMoneyBuyTips,
  getSuperMoneyFixInvestTips
}